export default {
  setBanks(state, data) {
    state.banks = data;
  },
  setBankMaxCode(state, data) {
    state.bankMaxCode = data;
  },

  setBankBranches(state, data) {
    state.bankBranches = data;
  },
  setBranchMaxCode(state, data) {
    state.branchMaxCode = data;
  },

  setBankCashAccountInfo(state, data) {
    state.bankCashAccountInfo = data;
  },
  setBankCashAccountId(state, data) {
    state.bankCashAccountId = data;
  },

  setBankCashAccountInfoById(state, data) {
    state.bankCashAccountInfoById = data;
  },
  setBankCashAccountInfoVoucher(state, data) {
    state.bankCashAccountInfoVoucher = data;
  },
  setBankCashAccountInfoCode(state, data) {
    state.bankCashAccountInfoCode = data;
  },

  setChequeStatuses(state, data) {
    state.chequeStatuses = data;
  },
  setChequeBatch(state, data) {
    state.chequeBatch = data;
  },

  setChequeBatchCode(state, data) {
    state.chequeBatchCode = data;
  },

  setChequeBatchDetail(state, date) {
    state.chequeBatchDetail = date;
  },

  setReceiveCashes(state, data) {
    state.receiveCashes = data;
  },
  setReceiveCash(state, data) {
    state.receiveCash = data;
  },

  setReceiveCashCode(state, data) {
    state.receiveCashCode = data;
  },

  setReceiveCashNavigation(state, data) {
    state.receiveCashNavigation = data;
  },

  setReceiveCashCheckDelete(state, data) {
    state.receiveCashCheckDelete = data;
  },

  setReceiveCashVoucher(state, data) {
    state.receiveCashVoucher = data;
  },

  setPaymentCashes(state, data) {
    state.paymentCashes = data;
  },
  setPaymentCash(state, data) {
    state.paymentCash = data;
  },

  setPaymentCashCode(state, data) {
    state.paymentCashCode = data;
  },

  setPaymentCashNavigation(state, data) {
    state.paymentCashNavigation = data;
  },

  setPaymentCashCheckDelete(state, data) {
    state.paymentCashCheckDelete = data;
  },

  setRequestPayments(state, data) {
    state.requestPayments = data;
  },
  setRequestPayment(state, data) {
    state.requestPayment = data;
  },
  setRequestPaymentCode(state, data) {
    state.requestPaymentCode = data;
  },
  setRequestPaymentNavigation(state, data) {
    state.requestPaymentNavigation = data;
  },

  setReceiveCheques(state, data) {
    state.receiveCheques = data;
  },
  setReceiveCheque(state, data) {
    state.receiveCheque = data;
  },

  setReceiveChequeCode(state, data) {
    state.receiveChequeCode = data;
  },

  setReceiveChequeBackNumber(state, data) {
    state.receiveChequeBackNumber = data;
  },

  setReceiveChequeBankTransfer(state, data) {
    state.receiveChequeBankTransfer = data;
  },

  setTransactionInfo(state, data) {
    state.transactionInfo = data;
  },

  setReceiveChequeSampleExcel(state, data) {
    state.receiveChequeSampleExcel = data;
  },

  setReceiveChequeCartable(state, data) {
    state.receiveChequeCartable = data;
  },

  setReceiveChequeVoucher(state, data) {
    state.receiveChequeVoucher = data;
  },

  setReceiveChequeNavigation(state, data) {
    state.receiveChequeNavigation = data;
  },

  setVoucherTemplate(state, data) {
    state.voucherTemplate = data;
  },

  setBankTransfers(state, data) {
    state.bankTransfers = data;
  },

  setAssignmentPersons(state, data) {
    state.assignmentPersons = data;
  },

  setSettlements(state, data) {
    state.settlements = data;
  },

  setReturnTransferreds(state, data) {
    state.returnTransferreds = data;
  },

  setCancellationReceivables(state, data) {
    state.cancellationReceivables = data;
  },

  setReturnReceivables(state, data) {
    state.returnReceivables = data;
  },

  setReturnGuarantees(state, data) {
    state.returnGuarantees = data;
  },

  setReturnAssignments(state, data) {
    state.returnAssignments = data;
  },

  setRequestPaymentConfirm(state, data) {
    state.requestPaymentConfirm = data;
  },

  setReceiveChequeTurns(state, data) {
    state.receiveChequeTurns = data;
  },
  setReceiveChequeTurn(state, data) {
    state.receiveChequeTurn = data;
  },

  setPaymentCheques(state, data) {
    state.paymentCheques = data;
  },
  setPaymentCheque(state, data) {
    state.paymentCheque = data;
  },

  setPaymentChequeCode(state, data) {
    state.paymentChequeCode = data;
  },

  setPaymentChequeNavigation(state, data) {
    state.paymentChequeNavigation = data;
  },

  setPaymentChequeCartable(state, data) {
    state.paymentChequeCartable = data;
  },

  setPaymentChequeCheckDelete(state, data) {
    state.paymentChequeCheckDelete = data;
  },

  setPaymentChequeSampleExcel(state, data) {
    state.paymentChequeSampleExcel = data;
  },

  setPaymentChequeVoucher(state, data) {
    state.paymentChequeVoucher = data;
  },

  setPaymentChequeTurns(state, data) {
    state.paymentChequeTurns = data;
  },
  setPaymentChequeTurn(state, data) {
    state.paymentChequeTurn = data;
  },

  setPassPayDocs(state, data) {
    state.passPayDocs = data;
  },

  setCancelPayableDocs(state, data) {
    state.cancelPayableDocs = data;
  },

  setReturnGuaranteeDocs(state, data) {
    state.returnGuaranteeDocs = data;
  },

  setReceiveChequeReport(state, data) {
    state.receiveChequeReport = data;
  },

  setReceiveCashAndCahPaymentReport(state, data) {
    state.receiveCashAndCahPaymentReport = data;
  },

  setMonthlyComparisonReceiveAndPaymentCashReport(state, data) {
    state.monthlyComparisonReceiveAndPaymentCashReport = data;
  },

  setHistoryReceiveChequeReport(state, data) {
    state.historyReceiveChequeReport = data;
  },

  setDueReceiveChequeReport(state, data) {
    state.dueReceiveChequeReport = data;
  },

  setMonthlyComparisonReceiveChequeReport(state, data) {
    state.monthlyComparisonReceiveChequeReport = data;
  },
  setSummaryReceiveChequeReport(state, data) {
    state.summaryReceiveChequeReport = data;
  },

  setPaymentChequeReport(state, data) {
    state.paymentChequeReport = data;
  },
  setHistoryPaymentChequeReport(state, data) {
    state.historyPaymentChequeReport = data;
  },
  setMonthlyComparisonPaymentChequeReport(state, data) {
    state.monthlyComparisonPaymentChequeReport = data;
  },
  setPaymentChequeToPersonReport(state, data) {
    state.paymentChequeToPersonReport = data;
  },
  setPaymentChequeToAccountInfoReport(state, data) {
    state.paymentChequeToAccountInfoReport = data;
  },
  setPaymentChequeTurnReport(state, data) {
    state.paymentChequeTurnReport = data;
  },
  setSummaryPaymentChequeReport(state, data) {
    state.summaryPaymentChequeReport = data;
  },
  setOverduePaymentChequeReport(state, data) {
    state.overduePaymentChequeReport = data;
  },

  setCirculationVoucherReport(state, data) {
    state.circulationVoucherReport = data;
  },

  setAccountInventoryReport(state, data) {
    state.accountInventoryReport = data;
  },
  setSummaryPaymentChequeTab(state, data) {
    state.summaryPaymentChequeTab = data;
  },
  setSummaryReceiveChequeTab(state, data) {
    state.summaryReceiveChequeTab = data;
  },
  setSummaryReceiveAndPaymentCash(state, data) {
    state.summaryReceiveAndPaymentCash = data;
  },

  setAccountConfig(state, data) {
    state.accountConfig = data;
  },

  setAccountInfo(state, data) {
    state.accountInfo = data;
  },
  setAccountInfoCode(state, data) {
    state.accountInfoCode = data;
  },

  setLastAccount(state, data) {
    state.lastAccount = data;
  },

  setVoucherNoteType(state, data) {
    state.voucherNoteType = data;
  },

  setDefaultVoucherDescription(state, data) {
    state.defaultVoucherDescription = data;
  },

  setFinancialRatio(state, data) {
    state.financialRatio = data;
  },

  setFinancialRatioItem(state, data) {
    state.financialRatioItem = data;
  },

  setNumerator(state, numeratorItems) {
    state.numerator = numeratorItems;
  },

  setDenominator(state, denominatorItems) {
    state.denominator = denominatorItems;
  },

  setVouchers(state, data) {
    state.vouchers = data;
  },
  setVouchersTotalCount(state, data) {
    state.vouchersTotalCount = data;
  },
  setVoucher(state, data) {
    state.voucher = data;
  },

  setVoucherNavigation(state, data) {
    state.voucherNavigation = data;
  },

  setVoucherCheckCreate(state, data) {
    state.voucherCheckCreate = data;
  },
  setVoucherCheckUpdate(state, data) {
    state.voucherCheckUpdate = data;
  },

  setVoucherId(state, data) {
    state.voucherId = data;
  },

  setLastVoucherInfo(state, data) {
    state.lastVoucherInfo = data;
  },

  setVoucherAttaches(state, data) {
    state.voucherAttaches = data;
  },

  setPersonCredits(state, data) {
    state.personCredits = data;
  },

  setUserLimitAccounts(state, data) {
    state.userLimitAccounts = data;
  },

  setVoucherNotes(state, data) {
    state.voucherNotes = data;
  },

  setConfirmCartable(state, data) {
    state.confirmCartable = data;
  },
  setUnConfirmCartable(state, data) {
    state.unConfirmCartable = data;
  },

  setVoucherReview(state, data) {
    state.voucherReview = data;
  },

  setEmptyVoucher(state, data) {
    state.emptyVoucher = data;
  },

  setArchiveVoucher(state, data) {
    state.archiveVoucher = data;
  },
  setDebtorOrCreditorDeclarations(state, data) {
    state.debtorOrCreditorDeclarations = data;
  },
  setDebtorOrCreditorDeclaration(state, data) {
    state.debtorOrCreditorDeclaration = data;
  },

  setDebtorOrCreditorDeclarationCode(state, data) {
    state.debtorOrCreditorDeclarationCode = data;
  },

  setDebtorOrCreditorDeclarationNavigation(state, data) {
    state.debtorOrCreditorDeclarationNavigation = data;
  },

  setDebtorOrCreditorDeclarationCheckDelete(state, data) {
    state.debtorOrCreditorDeclarationCheckDelete = data;
  },

};
